// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// CORE SCSS (our custom css)
import '@/css/_main.scss' ;//custom css

import Vue from 'vue';
import router from './router';
import Cookie from 'js-cookie';
import { i18n } from "./plugins/i18n";

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import functions from "@/plugins/functions"

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://04414d6d16a14b29ac43c86efc05b0a9@o19988.ingest.sentry.io/5384961',
    integrations: [new VueIntegration({Vue, attachProps: true})],
    beforeSend(event){
      if (!event.user) {
        event.user = {}
      }

      let user = functions.getUser()

      if (user) {
        event.user.username = user.Login
      }

      return event
    }
  });
}

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCQd0rbfcGuoTJQVsUEEsfbGl7Nh6izbHs",
    libraries: "places, geocoder" // necessary for places input
  }
});

//useful functions
import Utils from './plugins/utils';
Vue.use(Utils, {trans: i18n});

import App from './App';

import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import customParseFormat from "dayjs/plugin/customParseFormat"
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.tz.setDefault("Europe/Madrid")


Vue.config.productionTip = process.env.NODE_ENV !== 'production';

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

  let checkLoginStatus = function () {
    let nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title + " - " + process.env.MYAPP_NAME + " - thinkSPAIN";

    let isUser = Cookie.get('access_token')
    let isAdmin = Cookie.get('admin_access_token')

    let pathsThatRequireAdminAccess = ['/admin']
    let pathsThatRequireNoAuthentication = ['static/unsupported-browser.html', '/logout', '/']

    if (pathsThatRequireAdminAccess.includes(to.path)){
      if (isAdmin){
        next()
        return
      }
      router.push({path: '/?redirect=' + to.path, query: to.query})
      return
    }

    if (pathsThatRequireNoAuthentication.includes(to.path)){
      next()
      return
    }

    if (!isUser){
      router.push({path: '/?redirect=' + to.path, query: to.query})
      return
    }

    next()
    return
  }

  let hidePopovers = function() {
    $('.popover').popover('hide')
  }

  checkLoginStatus();
  hidePopovers();

  document.body.setAttribute('data-route', to.name)
});

/* eslint-disable no-new */
export const app = new Vue({
  el: '#app',
  router,
  i18n,
  Utils,
  components: {App},
  template: '<App/>'
})




//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = null
// module chunks = 